module.exports = __webpack_public_path__ + "static/media/sopt18kz.34be22a8.pdf";